import type { Location } from "@expert/sales-tools";

export function getLocationString(location: Location) {
    return [location.city, location.state].filter(Boolean).join(", ");
}
